import * as React from "react";
import { Icon } from "sb-resp-ui";
export const GameStateWrapperLiveOutright = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__clock`, "data-uat": `div-ev-list-${props.componentPrefix}-clock` },
    React.createElement(Icon, { i: `i-o-sport i-o-sport-${props.details.event.sportId}` }));
//# sourceMappingURL=GameStateWrapperLiveOutright.js.map